namespace Areas.Dialogs.IdentifyWeeklyOvertime {
    "use strict";

    let employeeId: number;
    let totalHours: number;
    let straightHours: number;
    let premiumHours: number;
    let weekEndDate: Date;
    let timeEntryStore: DevExpress.data.ArrayStore;
    let dataGrid: DevExpress.ui.dxDataGrid;

    export class IdentifyWeeklyOvertimeDialog extends Areas.BaseDialog {

        protected isPremiumOvertime: boolean;

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any = null) {
            super("IdentifyWeeklyOvertime", closeHandler, parameters, () => {
                $('#straightHours').text(parameters.straightHours);
                $('#premiumHours').text(parameters.premiumHours);

                straightHours = parameters.straightHours;
                premiumHours = parameters.premiumHours;
                totalHours = parameters.straightHours + parameters.premiumHours;
                employeeId = parameters.employeeId;
                weekEndDate = parameters.weekEndDate;

                disableButton("IdentifyWeeklyOvertimeOkDialog");
                this.getData();
           });
        }

        protected ok = (e: any) => {
            this.applyOvertime(this);
        }

        getData() {
            $.ajax({
                url: `/Dialog/IdentifyWeeklyOvertime/Get/${employeeId}/${weekEndDate}`,
                method: "GET",
                success: function (result) {
                    timeEntryStore = new DevExpress.data.ArrayStore({
                            data: result,
                            key: "timeEntryId"
                        });

                    const timeEntryDataSource = new DevExpress.data.DataSource({
                        store: timeEntryStore
                    });        

                    dataGrid = $('#GridContainer').dxDataGrid({
                        dataSource: timeEntryDataSource,
                        width: "97%",
                        allowColumnReordering: true,
                        allowColumnResizing: true,
                        columnHidingEnabled: true,
                        columnFixing: {
                            enabled: true
                        },
                        columnChooser: {
                            enabled: false,
                            mode: "select"
                        },
                        rowAlternationEnabled: true,
                        remoteOperations: false,
                        searchPanel: {
                            visible: true,
                            highlightSearchText: true,
                            searchVisibleColumnsOnly: true,
                            width: 300,
                            placeholder: "Search grid for ..."
                        },
                        selection: {
                            mode: "single",
                            showCheckBoxesMode: "none",
                            allowSelectAll: false
                        },
                        paging: {
                            pageSize: 10
                        },
                        pager: {
                            visible: true,
                            showPageSizeSelector: true,
                            allowedPageSizes: [
                                10,
                                50,
                                200,
                                1000
                            ]
                        },
                        groupPanel: {
                            visible: true
                        },
                        grouping: {
                            autoExpandAll: true
                        },
                        headerFilter: {
                            visible: true
                        },
                        editing: {
                            mode: "batch",
                            allowAdding: false,
                            allowUpdating: true,
                            allowDeleting: false
                        },
                        onToolbarPreparing: Areas.addButtonsToToolbar(["columnChooser", "export" ]),
                        onSaved:Areas.Dialogs.IdentifyWeeklyOvertime.saved,
                        columns: [
                            {
                                dataField: "usageDate",
                                caption: "Date",
                                format: "longDate",
                                width: 80,
                                groupIndex: 0,
                                sortOrder: "asc",
                                sortIndex: 0,
                                dataType: "date"
                            }, {
                                dataField: "accountCode",
                                caption: "Project",
                                width: 100
                            }, {
                                dataField: "workOrderCode",
                                caption: "Job Code",
                                width: 100
                            }, {
                                dataField: "workOrderLongDescription",
                                caption: "Job Description",
                                width: 400
                            }, {
                                dataField: "usageAmount",
                                caption: "Hours",
                                width: 100,
                                dataType: "number"
                            }, {
                                dataField: "isStraightHours",
                                caption: "Straight Overtime",
                                width: 120,
                                allowEditing: true,
                                dataType: "boolean"
                            }, {
                                dataField: "isPremiumHours",
                                caption: "Premium Overtime",
                                width: 120,
                                allowEditing: true,
                                dataType: "boolean"
                            }
                        ],
                        summary: {
                            groupItems: [
                                {
                                    column: "usageAmount",
                                    summaryType: "sum",
                                    displayFormat: "Total Hours: {0}"
                                }
                            ]
                        }
                    }).dxDataGrid('instance');
                }
            })
        }

        applyOvertime(that: any) {
            var selections = timeEntryStore.createQuery()
                .filter([["isStraightHours", "=", true], "or", ["isPremiumHours", "=", true]])
                .select("timeEntryId", "isStraightHours", "isPremiumHours")
                .toArray();

            console.log(selections); 
            $.ajax({
                url: "/Dialog/IdentifyWeeklyOvertime/ApplyOvertime",
                method: "POST",
                data: { timeEntries: selections, weekEndDate: weekEndDate },
                success: function (result) {
                    that.close(DialogResult.Ok, null);
                },
                error: function (msg: any) {
                    DevExpress.ui.notify("Error in request: " + msg.responseText, "error", 3000);
                }
            });
        }
    }

    export function saved(e) {
        var data = timeEntryStore.createQuery()
            .filter([["isStraightHours", "=", true], "or", ["isPremiumHours", "=", true]])
            .select("usageAmount", "isStraightHours", "isPremiumHours")
            .toArray()
            .map(function (x) { 
            return { 
                "usageAmount": x.usageAmount,
                "straightHours": x.isStraightHours ? x.usageAmount : 0,
                "premiumHours": x.isPremiumHours ? x.usageAmount : 0 
            };
        });

        var sums = data
            .reduce((acc, curr) => {
                {
                    acc["totalSelectedHours"] = acc["totalSelectedHours"] + curr.usageAmount;
                    acc["totalSelectedStraightHours"] = acc["totalSelectedStraightHours"] + curr.straightHours;
                    acc["totalSelectedPremiumHours"] = acc["totalSelectedPremiumHours"] + curr.premiumHours;
                    return acc;
                }
            },
            { 
                "totalSelectedHours": 0,
                "totalSelectedStraightHours": 0,
                "totalSelectedPremiumHours": 0
            });

        if (sums.totalSelectedHours >= totalHours
            && sums.totalSelectedStraightHours >= straightHours
            && sums.totalSelectedPremiumHours >= premiumHours) {
            enableButton("IdentifyWeeklyOvertimeOkDialog");
        } else {
            disableButton("IdentifyWeeklyOvertimeOkDialog");
        }

        $('#selectedTotal').text(`${sums.totalSelectedHours}; total straight ${sums.totalSelectedStraightHours}; total premium ${sums.totalSelectedPremiumHours}`);
    }

}
